import axios from "axios";
import Cookies from "js-cookie";

const token = Cookies.get("redlotus_security");

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
  },
});

axiosClient.interceptors.request.use(
  async (config) => {
    try {
      const token = Cookies.get("redlotus_security");

      if (token) {
        config.headers["Authorization"] = "Bearer " + token;
      } else {
        config.headers["Authorization"] = "";
      }
      return config;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  (err) => {
    return Promise.reject(err);
  },
);

axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      Cookies.remove("redlotus_security", { path: "/" });
      // Prevent redirect loop
      if (typeof window !== "undefined" && window.location.pathname !== "/") {
        window.location.replace("/");
      }
    }

    // if (error?.response?.status === 401) {
    //   window.dispatchEvent(
    //     new CustomEvent("session-expired", {
    //       detail: {
    //         title: "Access Denied",
    //         message:
    //           error?.response?.data?.errors ||
    //           "Your session has expired. Please login again.",
    //       },
    //     }),
    //   );

    //   return Promise.reject({
    //     ...error,
    //     handled: true,
    //   });
    // }

    return Promise.reject(error);
  },
);

export default axiosClient;
